module.exports = __webpack_public_path__ + "img/source_mg-03.f70fb8f2.png";